export default "__VITE_ASSET__kjw3GcMz__"